import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders, cancelOrder, submitReview } from "../../Features/Order/userorderhistory";
import { Button, Modal, Rating, TextField } from "@mui/material";
import { uploadImages } from "../Authentication/firebase/uploadmutiplefile";
import { useAuth } from "../../Auth/AuthContext copy";
import { CircularProgress } from "@mui/material";
import "./OrderHistory.css";
import toast from "react-hot-toast";
import CircleLoading from "../CirculusIndicator/CircleLoading";
const OrderHistory = () => {
    const dispatch = useDispatch();
    const { orders = [], loading } = useSelector((state) => state.orders);
    const { currentUser } = useAuth();

    const [reviewData, setReviewData] = useState({ currentUser: null, orderId: null, productId: null, rating: 0, text: "", images: [], orderduser: null });
    const [isReviewModalOpen, setReviewModalOpen] = useState(false);
    const [loadingReview, setLoadingReview] = useState(false);
    useEffect(() => {
        if (currentUser) {
            dispatch(fetchOrders(currentUser.uid));
        }
    }, [dispatch, currentUser]);

    const handleCancelOrder = (orderId) => {
        dispatch(cancelOrder(orderId));
    };

    const handleReviewSubmit = async () => {
        setLoadingReview(true);
        const uploadedImages = await uploadImages(reviewData.images);
        dispatch(submitReview({ ...reviewData, images: uploadedImages }));
        setLoadingReview(false);
        setReviewModalOpen(false);
        toast.success("Review submitted successfully!", {
            duration: 2000,
            style: {
                backgroundColor: "#07bc0c",
                color: "white",
            },
            iconTheme: {
                primary: "#fff",
                secondary: "#07bc0c",
            },
        });
        setReviewData({ rating: 0, text: "", images: [] });
    };
    const removeImage = (index) => {
        setReviewData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index),
        }));
    };
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const imageFiles = files.filter(file => file.type.startsWith("image/")); // Only accept images

        if (reviewData.images.length + imageFiles.length > 4) {
            toast.error("You can only select up to 4 images.");
            return;
        }

        setReviewData(prev => ({ ...prev, images: [...prev.images, ...imageFiles] }));
    };

    return (
        <div className="order-history-container">
            <h2 className="order-history-title">Your Orders</h2>

            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                ><CircleLoading /></div>
            ) : orders.length === 0 ? (
                <p className="no-orders">No orders found.</p>
            ) :
                (orders.map((order) => (
                    <div key={order.id} className="order-card">
                        <h3 className="order-id">Order #{order.id.slice(0, 8)}</h3>
                        <p className="order-status">
                            Status: <span className={order.orderedStatus === "Pending" ? "status-pending" : "status-delivered"}>{order.orderedStatus}</span>
                        </p>
                        <p className="total-price">Total: Rs.{order.totalPrice}</p>
                        <p className="payment"> <strong>Payment Mode:</strong> {order.paymentMode}</p>
                        <div className="products-list">
                            {order.productOrdered?.map((product) => (
                                <div key={product.productID} className="product-item">
                                    <img src={product.frontImg} alt={product.productName} className="product-image" />
                                    <div className="product-details">
                                        <p className="product-name">{product.productName}</p>
                                        <p className="product-price"><strong>Price: </strong> Rs.{product.productPrice}</p>
                                        <p className="product-quantity"><strong>Quantity: </strong> {product.quantity}</p>
                                        {product.size && <p className="product-size"><strong>Size: </strong> {product.size}</p>}
                                        {product.color && (
                                            <p className="product-color"><strong>Color: </strong> {product.color} </p>
                                        )}
                                        {order.orderedStatus === "Delivered" && (
                                            product.review ? (
                                                <p className="review-success">Review Submitted</p> // Success message
                                            ) : (
                                                <div className="review-button-container">  <Button
                                                    onClick={() => {
                                                        setReviewData({
                                                            ...reviewData,
                                                            productId: product.productID,
                                                            orderId: order.id,
                                                            currentUser: currentUser,
                                                            orderduser: order.orderedUserName,
                                                        });
                                                        setReviewModalOpen(true);
                                                    }}
                                                >
                                                    Leave a Review
                                                </Button>
                                                </div>

                                            )
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <p className="phone"> <strong>Contact:</strong> {order.phone}</p>
                        <p className="Address"> <strong>Address:</strong> {order.address}</p>
                        {order.orderedStatus === "Pending" && (
                            <div className="cancel-button-container">
                                <Button onClick={() => handleCancelOrder(order.id)}>
                                    Cancel Order
                                </Button>
                            </div>
                        )}
                    </div>

                ))
                )
            }

            <Modal open={isReviewModalOpen} onClose={() => setReviewModalOpen(false)}>
                <div className="review-modal">
                    <h3 className="modal-title">Leave a Review</h3>

                    <Rating
                        value={reviewData.rating}
                        onChange={(event, newValue) => setReviewData({ ...reviewData, rating: newValue })}
                    />

                    <TextField
                        label="Write a review..."
                        variant="outlined"
                        fullWidth
                        onChange={(e) => setReviewData({ ...reviewData, text: e.target.value })}
                        className="review-input"
                    />

                    {/* File Input */}
                    <input
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handleFileChange}
                        className="file-input"
                    />

                    {/* Display Selected Images */}
                    <div className="image-preview-container">
                        {reviewData.images.map((image, index) => (
                            <div key={index} className="image-preview">
                                <img src={URL.createObjectURL(image)} alt="preview" />
                                <button onClick={() => removeImage(index)}>✖</button>
                            </div>
                        ))}
                    </div>

                    <Button className="submit-review-button" onClick={handleReviewSubmit} disabled={loadingReview}>
                        {loadingReview ? <CircularProgress size={24} color="inherit" /> : "Submit Review"}
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default OrderHistory;
